module.exports = __webpack_public_path__ + "img/s2.9a38a864.png";